import { parseHeatmapWidgetInternalState } from 'src/pages/dashboard/features/heatmap-widget/parseHeatmapWidget';

import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { HeatmapWidgetEntity } from 'src/pages/dashboard/features/heatmap-widget/HeatmapWidget.entity';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function heatmapApplyChanges(widget: HeatmapWidgetEntity, changes: TSerializedWidget, index: number) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseHeatmapWidgetInternalState(changes.internalState ?? {});

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
